import { useEffect, useRef } from 'react';

const useOutsideClick = (callback: () => void): React.RefObject<HTMLDivElement | null> => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent): void => {
      const element = ref.current;
      const target = event.target as Node | null;

      if (!element) return;

      const isClickInside = element.contains(target);
      const isClickOutside = !isClickInside;

      if (isClickOutside) {
        callback();
      }
    };

    document.addEventListener('click', handleClick, true);

    return () => document.removeEventListener('click', handleClick, true);
  }, [callback]);

  return ref;
};

export default useOutsideClick;
